import MainVue from '../components/MainVue.vue'
import AboutPage from '../components/Pages/AboutPage.vue'
import ProjectsPage from '../components/Pages/ProjectsPage.vue'
export const routes=[
{
  path:'',
  component:MainVue
},{
  path:'/about',
  component:AboutPage
},{
  path:'/projects',
  component:ProjectsPage
}


]